export const StorageKey = {
  THEME: 'theme',
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',

  CSRF_ACCESS_TOKEN: 'csrf_access_token',
  CSRF_REFRESH_TOKEN: 'csrf_refresh_token',
  ACCESS_TOKEN_COOKIE: 'access_token_cookie',
  REFRESH_TOKEN_COOKIE: 'refresh_token_cookie',

  DISABLE_RELOAD_USER: '_disableReloadUser',
};
